const APPSDEVELOPER_CLUSTER = {
    mini_site: {
        logo: {
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/apps/desktop_open_monday_apps_logo.png',
            alt: 'monday.com for apps developers',
            url: '/appsdeveloper',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/apps/mobile_monday_apps_logo.png',
            useDesktopLogoInMobile: 'true',
        },
        links: [
            {
                url: '/appdeveloper',
                text: 'minisite.header.overview',
                removeFromUnified: 'true',
            },
            {
                url: '/appdeveloper/resources',
                text: 'Resources',
            },
            {
                url: '/appdeveloper/components',
                text: 'Components',
            },
            {
                url: '/appdeveloper/appideas',
                text: 'App ideas',
            },
            {
                url: '/appdeveloper/monetization',
                text: 'minisite.header.monetization',
            },
        ],
        unifiedDesktopLogo: {
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/apps/desktop_close_monday_apps_logo.png',
            url: '/appsdeveloper',
            alt: 'monday.com for apps developers',
        },
    },
};

export { APPSDEVELOPER_CLUSTER };
